import React from "react";
import { Link } from "react-router";

import { Card, CardHeader, CardTitle, CardContent, CardFooter } from "./ui/card";

import { kilnLogo, controllerLogo } from "../helpers/logoHelpers";

const KilnCard = (props: any) => {
  return (
    <Link to={`/kilns/${props.id}`}>
      <Card className="cursor-pointer hover:shadow-md transition-shadow h-full flex flex-col">
        <CardHeader><CardTitle className="text-base">{props.name}</CardTitle></CardHeader>
        <CardContent className="flex-1">
          <img className="max-w-full" src={kilnLogo(props.manufacturer)} alt="" />
        </CardContent>
        <CardFooter>
          {props.controller === "bartlett_genesis" && (
            <img className="max-w-full" src={controllerLogo(props.controller)} alt="" />
          )}
        </CardFooter>
      </Card>
    </Link>
  );
};

export default KilnCard;
